import AsharqLogo from "@public/home/press/asharq_logo.svg";
import BloombergLogo from "@public/home/press/bloomberg_logo.svg";
import CairoSceneLogo from "@public/home/press/cairo_scene_logo.png";
import EnterpriseLogo from "@public/home/press/enterprise_logo.svg";
import ForbesLogo from "@public/home/press/forbes_logo_black.svg";
import MenaBytesLogo from "@public/home/press/menabytes_logo.png";
import WamdaLogo from "@public/home/press/wamda-logo.png";
import { cn } from "@/ui/utils/cn";
import { track } from "@services/analytics";
import { LicenceLine } from "@components/shared/LicenceLine";
import { useTranslations } from "@services/strings";
import Image from "next/image";
import Marquee from "react-fast-marquee";

export const PRESS = [
  {
    alt: "Forbes Middle East",
    logo: ForbesLogo,
    href: "https://www.forbesmiddleeast.com/innovation/startups/egypt-based-mnzl-raises-%2435m-in-funding-round-to-revolutionize-asset-backed-lending-in-egypt",
  },
  {
    alt: "Bloomberg Asharq",
    logo: BloombergLogo,
    href: "https://now.asharq.com/clip/%D8%AA%D8%B7%D8%A8%D9%8A%D9%82-mnzl-%D9%84%D9%84%D8%AA%D9%83%D9%86%D9%88%D9%84%D9%88%D8%AC%D9%8A%D8%A7-%D8%A7%D9%84%D9%85%D8%A7%D9%84%D9%8A%D8%A9-%D9%8A%D8%AC%D9%85%D8%B9-35-%D9%85%D9%84%D9%8A%D9%88%D9%86-%D8%AF%D9%88%D9%84%D8%A7%D8%B1",
  },
  {
    alt: "Asharq News",
    logo: AsharqLogo,
    href: "https://now.asharq.com/clip/%D8%AA%D8%B7%D8%A8%D9%8A%D9%82-mnzl-%D9%84%D9%84%D8%AA%D9%83%D9%86%D9%88%D9%84%D9%88%D8%AC%D9%8A%D8%A7-%D8%A7%D9%84%D9%85%D8%A7%D9%84%D9%8A%D8%A9-%D9%8A%D8%AC%D9%85%D8%B9-35-%D9%85%D9%84%D9%8A%D9%88%D9%86-%D8%AF%D9%88%D9%84%D8%A7%D8%B1",
  },
  {
    alt: "Enterprise",
    logo: EnterpriseLogo,
    href: "https://enterprise.news/egypt/en/news/story/50e3316a-ae1c-4bbb-80b6-c6f4b13a812d/fintech-startup-mnzl-raises-usd-3.5-mn-in-funding-round",
  },
  {
    alt: "Wamda",
    logo: WamdaLogo,
    href: "https://www.wamda.com/2024/05/egypt-mnzl-raises-3-5-million-seed-led-p1-ventures",
  },
  {
    alt: "Cairo Scene",
    logo: CairoSceneLogo,
    href: "https://cairoscene.com/Business/Fintech-Startup-MNZL-Raises-3-5M-to-Introduce-New-Lending-Options",
  },
  {
    alt: "MENAbytes",
    logo: MenaBytesLogo,
    href: "https://www.menabytes.com/mnzl-investment/",
  },
];

/** Scrolling row of press logos. Pauses on hover; always scrolls LTR. */
export const PressMarquee = ({
  gradientColor = "#FFFFFF",
  className,
}: {
  gradientColor?: string;
  className?: string;
}) => (
  <div className={cn("w-full overflow-hidden", className)} dir="ltr">
    <Marquee
      gradient
      gradientColor={gradientColor}
      pauseOnHover
      speed={30}
      autoFill
    >
      {PRESS.map((item) => (
        <a
          key={item.alt}
          href={item.href}
          target="_blank"
          rel="noopener"
          className="mx-7 inline-flex items-center opacity-70 grayscale transition-opacity hover:opacity-100"
          onClick={() =>
            track({
              event: "Link Clicked",
              properties: { from: "press", to: item.href, label: item.alt },
            })
          }
        >
          <Image
            src={item.logo}
            alt={item.alt}
            height={26}
            className="h-[26px] w-auto"
          />
        </a>
      ))}
    </Marquee>
  </div>
);

/** Regulator line + press logos. */
export const Trust = () => {
  const { t } = useTranslations();

  return (
    <section className="border-y border-slate-100 bg-white py-12 md:py-16">
      <div className="container flex flex-col gap-10">
        <div className="flex flex-col items-start gap-5 md:flex-row md:items-center md:gap-8">
          <Image
            src="/fra.svg"
            alt="Financial Regulatory Authority"
            width={72}
            height={72}
          />
          <div>
            <p className="text-h3 font-semibold">{t("site.legal.title")}</p>
            <LicenceLine className="mt-1 max-w-prose" />
          </div>
        </div>
        <div>
          <p className="mb-5 text-sm text-slate-500">
            {t("site.common.featuredIn")}
          </p>
          <PressMarquee />
        </div>
      </div>
    </section>
  );
};
